<template>
  <el-dialog
    width="360px"
    title="Удаление объектов"
    :visible="visible"
    @close="cancel"
    class="map-editor-delete-modal"
  >
    <div class="map-editor-delete-modal__container">
      {{ getText() }}
    </div>
    <div slot="footer" class="gcp-settings__actions">
      <el-button
        class="r-button plain"
        type="primary"
        size="mini"
        @click="cancel"
      >
        Отменить
      </el-button>
      <el-button
        class="r-button danger"
        type="danger"
        size="mini"
        @click="deleteObjects"
      >
        Удалить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["editor-state", "draw", "visible"],
  methods: {
    getText() {
      const { deletingIds, dependenciesCount } = this.editorState;

      return `
        При удалении ${
          deletingIds.length === 1 ? "данного объекта" : "данных объектов"
        }
        также будут удалено ${dependenciesCount} зависимых объекта(-ов)
      `;
    },
    cancel() {
      this.$emit("toggle-delete-modal", false);
      this.draw.changeMode("simple_select", {
        featureIds: []
      });
    },
    deleteObjects() {
      const { deletingCallback } = this.editorState;

      deletingCallback();
      this.$emit("toggle-delete-modal", false);
    }
  }
};
</script>

<style lang="scss">
.map-editor-delete-modal {
  &__container {
    font-size: 14px;
    word-break: break-word;
    color: var(--text_secondary) !important;
  }
}
</style>
